import React from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
//import { Collapse } from "react-collapse";
import FormsRICadastro from './../../../components/Forms_RepresentanteDeInstituição/Tela_RI_Cadastro';
//import FormUser from './../../../components/Form_Axios';
//import { NavLink } from 'react-router-dom';
import SideNav from './../../../components/SideNav_RI';

export default function RI_Cadastro() {
    //let [search, setSearch] = useState(false);
    //let [login, setLogin] = useState(false);
    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro"></div>
            <div id="main-RI-Cadastro">
                <p id="RI-Cadastro">Cadastro</p>
                <hr id="divider-RI-Cadastro" />
                <div id="collapsed-RI-Cadastro">
                    <FormsRICadastro />
                </div>
            </div>
        </>
    );
}